import { useEffect, useState } from 'react';
import { GetRegionalOffices } from '../network/Region';
import { useAuth } from '../../components/customContextProviders/AuthContext';
import { APP_CONSTANTS } from '../../URLConstants';
import { parseValidationErrorMessage } from '../../utils/Utilities';


export function useRegions() {
  const { fetchZonesList, sessionUserData, fetchTaxonomyDetails, fetchHeadOfficesList } = useAuth()
  const [page, setPage] = useState(1);
  const [searchText, setSearchText] = useState('');
  const [regionModalOpen, setRegionModalOpen] = useState(false)
  const [regionsListData, setRegionsListData] = useState({
    loading: false,
    data: [],
    metas: {}
  });
  const [selectedRegionForAction, setSelectedRegionForAction] = useState({
    region: {},
    action: null
  })

  const [isSnackBarAlertOpen, setIsSnackBarAlertOpen] = useState(false);
  const [snackBarMetas, setSnackBarMetas] = useState({
    title: '',
    message: '',
    severity: 'info',
    handleClose: null
  });

  const handleChangePage = (data, customPage) => {
    const where = {
      ...(searchText ? { name: searchText } : {}),
    }
    let newPage = page;
    if (data === 'NEXT') newPage += 1;
    else newPage -= 1;

    if (customPage) {
      setPage(customPage);
      fetchRegions(customPage, where);
      return;
    }
    setPage(newPage);
    fetchRegions(newPage, where);
  };

  const fetchRegions = (targetPage = 1, where = {}) => {
    setRegionsListData((prev) => ({
      ...prev,
      loading: true
    }))
    GetRegionalOffices(targetPage, 10, where)
      .then((response) => {
        setRegionsListData((prev) => ({
          ...prev,
          data: response?.data?.data,
          metas: response?.data,
          loading: false
        }))

      })
      .catch(() => {
        setRegionsListData((prev) => ({
          ...prev,
          loading: false
        }))
      })
  };

  const handleSearch = (value) => {
    setSearchText(value);
    const where = {
      ...(value ? { name: value } : {})
    }
    fetchRegions(1, where);
  };

  const handleRegionMoreMenuClick = (action, regionData) => {
    switch (action) {
      case 'update_region': {
        fetchTaxonomyDetails(sessionUserData?.user?.taxonomyId);
        fetchHeadOfficesList();
        fetchZonesList();
        setRegionModalOpen(true);
        setSelectedRegionForAction({
          region: regionData,
          action: 'update_region'
        });

        break;
      }
      default: {
        return '';
      }
    }
  };

  function onUpdateRegionAction(action, msg) {
    const where = {
      ...(searchText ? { name: searchText } : {})
    }
    if (action === APP_CONSTANTS?.REGION_UPDATE_SUCCESSFULL) {
      const currentPage = 1;
      setPage(currentPage)
      fetchRegions(currentPage, where);

      setSnackBarMetas((prevState) => ({
        ...prevState,
        title: msg,
        severity: 'success'
      }));
      setIsSnackBarAlertOpen(true);
    } else if (action === APP_CONSTANTS?.REGION_UPDATE_UNSUCCESSFULL) {
      setSnackBarMetas((prevState) => ({
        ...prevState,
        title: parseValidationErrorMessage(msg),
        severity: 'error'
      }));
      setIsSnackBarAlertOpen(true);
    } else if (action === APP_CONSTANTS?.NO_CHANGES) {
      setSnackBarMetas((prevState) => ({
        ...prevState,
        title: msg,
        severity: 'info'
      }));
      setIsSnackBarAlertOpen(true);
    }
  }

  useEffect(() => {
    fetchRegions(1);
    fetchZonesList()
  }, []);


  return {
    page,
    searchText,
    setSearchText,
    regionsListData,

    handleChangePage,
    handleSearch,
    fetchRegions,
    setPage,
    isSnackBarAlertOpen,
    setSnackBarMetas,
    setIsSnackBarAlertOpen,
    snackBarMetas,
    handleRegionMoreMenuClick,
    regionModalOpen,
    setRegionModalOpen,
    selectedRegionForAction,
    onUpdateRegionAction,
    setSelectedRegionForAction
  };
}